<template>

    <div class="flex mb-2">
        <Toolbar class="w-full">
            <template #end>
                <DatePicker v-model="datePiker" dateFormat="dd/mm/yy" showIcon @value-change="onDateChange" />
            </template>
        </Toolbar>
    </div>

    <div class="flex gap-2 pt-2.5">
        <Card class="flex-1" style="text-align: center">
            <template #content>
                <div class="font-bold text-2xl">{{ infosGerais.totalClientes }}</div>
                <div class="font-medium text-orange-500"><b>Clientes</b></div>
            </template>
        </Card>

        <Card class="flex-1" style="overflow: hidden; text-align: center">
            <template #title>
                <b>{{ infosGerais.totalUsuarios }}</b>
            </template>
            <template #content>
                <p class="m-0 text-orange-500"><b>Usuários</b></p>
            </template>
        </Card>

        <Card class="flex-1" style="overflow: hidden; text-align: center">
            <template #title>
                <b>{{ infosGerais.totalContratosAtivos }}</b>
            </template>
            <template #content>
                <p class="m-0 text-orange-500"><b>Contratos Ativos</b></p>
            </template>
        </Card>

        <Card class="flex-1" style="overflow: hidden; text-align: center">
            <template #title>
                <b>{{ infosGerais.totalEmContratacao }}</b>
            </template>
            <template #content>
                <p class="m-0 text-orange-500"><b>Em Contratação</b></p>
            </template>
        </Card>

        <Card class="flex-1" style="overflow: hidden; text-align: center">
            <template #title>
                <b>{{ infosGerais.totalPendencias }}</b>
            </template>
            <template #content>
                <p class="m-0 text-red-500"><b>Pendências</b></p>
            </template>
        </Card>
    </div>

    <div>
        <div class="flex gap-2 my-2">

            <Card class="flex-1">
                <template #title>
                    <h4 class="m-0">ETAPAS / SEMANA ATUAL</h4>
                </template>
                <template #content>
                    <Chart v-if="etapasDias?.labels?.length && etapasDias?.datasets?.length" type="line" :data="etapasDias" :options="estiloEtapasDias" />
                </template>
            </Card>

            <Card class="flex-1">
                <template #title>
                    <h4 class="m-0">ETAPAS / SEMANA ATUAL</h4>
                </template>
                <template #content>
                    <DataTable :value="etapasDias?.datasets || []" size="small" stripedRows showGridlines
                        scrollable scrollHeight="calc(100vh - 300px)">

                        <Column field="label" header="Etapa"></Column>

                        <template v-for="(label, index) in (etapasDias?.labels || [])" :key="index">
                            <Column :header="label" bodyClass="text-center" >
                                <template #body="{ data }">{{data.data[index]}}</template>
                            </Column>
                        </template>

                        <template #empty>
                            <div class="text-center text-gray-600">
                                Nenhum registro encontrado
                            </div>
                        </template>

                    </DataTable>
                </template>
            </Card>
        </div>

        <div class="flex gap-2 my-2">

            <Card class="flex-1">
                <template #title>
                    <h4 class="m-0">QTD / ETAPAS</h4>
                </template>
                <template #content>
                    <Chart v-if="qtdEtapas?.labels?.length && qtdEtapas?.datasets?.length" type="bar" :data="qtdEtapas" :options="estiloColunaVertical" />
                </template>
            </Card>

            <Card class="flex-1">
                <template #title>
                    <h4 class="m-0">CONTRATOS / FUNCIONÁRIOS MAIORES- MÊS ATUAL</h4>
                </template>
                <template #content>
                    <Chart v-if="usuariosContratosMesMaiores?.labels?.length && usuariosContratosMesMaiores?.datasets?.length" type="bar" :data="usuariosContratosMesMaiores" :options="estiloColunaHorizontal" />
                </template>
            </Card>

            <Card class="flex-1">
                <template #title>
                    <h4 class="m-0">CONTRATOS / FUNCIONÁRIOS MENORES- MÊS ATUAL</h4>
                </template>
                <template #content>
                    <Chart v-if="usuariosContratosMesMenores?.labels?.length && usuariosContratosMesMenores?.datasets?.length" type="bar" :data="usuariosContratosMesMenores" :options="estiloColunaHorizontal" />
                </template>
            </Card>
        </div>

        <div class="flex gap-2 my-2">
            <Card class="flex-1">
                <template #title>
                    <h4 class="m-0">CONTRATOS CONCLUÍDOS/ MÊS</h4>
                </template>
                <template #content>
                    <Chart v-if="contratosMes?.labels?.length && contratosMes?.datasets?.length" type="polarArea" :data="contratosMes" :options="estiloGeral" />
                </template>
            </Card>

            <Card class="flex-1">
                <template #title>
                    <h4 class="m-0">ATUAÇÃO / ESTADO</h4>
                </template>
                <template #content>
                    <Chart v-if="atuacaoEstado?.labels?.length && atuacaoEstado?.datasets?.length" type="pie" :data="atuacaoEstado" :options="estiloGeral" />
                </template>
            </Card>
        </div>

        <div class="flex gap-2 my-2">
            <Card class="flex-1">
                <template #title>
                    <h4 class="m-0">CONTRATOS/MÊS ULTIMO ANO</h4>
                </template>
                <template #content>
                    <Chart v-if="etapasMes?.labels?.length && etapasMes?.datasets?.length" type="line" :data="etapasMes" :options="estiloEtapasDias" />
                </template>
            </Card>

            <Card class="flex-1">
                <template #title>
                    <h4 class="m-0">MAIORES CLIENTES</h4>
                </template>
                <template #content>
                    <Chart v-if="contratoMaioresClientes?.labels?.length && contratoMaioresClientes?.datasets?.length" type="bar" :data="contratoMaioresClientes" :options="estiloColunaVertical" />
                </template>
            </Card>
        </div>

    </div>
</template>

<script>
import Message from 'primevue/message';
import Button from "primevue/button";
import SafeChart from '@/components/SafeChart.vue';
import Card from 'primevue/card';
import BlockUI from 'primevue/blockui';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Toolbar from 'primevue/toolbar';
import DatePicker from 'primevue/datepicker';

import Cliente from '@/service/cliente.js';
import Usuario from '@/service/usuario.js';
import Contrato from '@/service/contrato.js';
import Pendencia from '@/service/pendencia.js';

export default {
    components: {
        Message,
        Button,
        Chart: SafeChart,
        Card,
        BlockUI,
        DataTable,
        Column,
        Toolbar,
        DatePicker,
    },
    data() {
        return {
            datePiker: new Date,
            infosGerais: {
                totalClientes: 0,
                totalUsuarios: 0,
                totalContratosAtivos: 0,
                totalEmContratacao: 0,
                totalPendencias: 0,
            },

            estiloGeral: {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: 'top'
                    }
                },
            },

            estiloEtapasDias: {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: 'top'
                    }
                }
            },

            estiloColunaHorizontal: {
                indexAxis: 'y',
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: 'top'
                    }
                }
            },
            estiloColunaVertical: {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: 'top'
                    }
                }
            },

            etapasDias: {},
            etapasMes: {},
            qtdEtapas: {},
            usuariosContratosMesMaiores: {},
            usuariosContratosMesMenores: {},
            contratosMes: {},
            atuacaoEstado: {},
            contratoMaioresClientes: {},
        }
    },
    mounted() {
        this.onDateChange();
    },
    methods: {
        onDateChange() {
            this.loadTotais();
            this.loadEtapasSemanal();
            this.loadEtapasMensal();
            this.loadEtapasQuantidades();
            this.loadMaioresUsuarios();
            this.loadMenoresUsuarios();
            this.loadMeses();
            this.loadEstados();
            this.loadClientes();
        },
        loadEtapasSemanal() {
            let date = this.datePiker;
            Contrato.etapasSemanal([`data=${date.toISOString().split('T')[0]}`].join("&"))
                .then(response => {
                    const data = response.data.data;
                    const labels = response.data.labels;
                    const datasets = [];
                    data.forEach((item, idx) => {
                        item.etapas.forEach((item2, idx2) => {
                            if (!datasets[idx2]) {
                                datasets[idx2] = {
                                    label: item2.etapa,
                                    data: [],
                                    tension: 0.4,
                                }
                            }
                            datasets[idx2].data.push(item2.total);
                        });
                    });

                    this.etapasDias = {
                        labels: labels,
                        datasets: datasets,
                    }
                });
        },
        loadEtapasMensal() {
            let date = this.datePiker;
            Contrato.etapasMensal([`data=${date.toISOString().split('T')[0]}`].join("&"))
                .then(response => {
                    const data = response.data.data;
                    const labels = response.data.labels;
                    const datasets = [
                        { label: 'Ativos', data: [], tension: 0.4 },
                        { label: 'Cancelamentos', data: [], tension: 0.4 },
                        { label: 'Crecimento', data: [], tension: 0.4 },
                    ];

                    data.forEach((item, idx) => {
                        datasets[0].data.push(item.concuido);
                        datasets[1].data.push(item.cancelado);
                        datasets[2].data.push(item.concuido - item.cancelado);
                    });

                    this.etapasMes = {
                        labels: labels,
                        datasets: datasets,
                    }
                });
        },

        loadEtapasQuantidades() {
            let date = this.datePiker;
            Contrato.etapasQuantidade([`data=${date.toISOString().split('T')[0]}`].join("&"))
                .then(response => {
                    const data = response.data.data;
                    const labels = [];
                    const datasets = [
                        { label: 'Status', data: [] },
                        { label: 'Pendências', data: [] }
                    ];

                    data.forEach((item, idx) => {
                        if (!labels[idx]) {
                            labels[idx] = item.etapa;
                        }
                        datasets[0].data.push(item.total);
                        datasets[1].data.push(item.pendencias);
                    });

                    this.qtdEtapas = {
                        labels: labels,
                        datasets: datasets,
                    }
                });
        },
        loadMaioresUsuarios() {
            let date = this.datePiker;
            Contrato.usuariosQuantidade([`data=${date.toISOString().split('T')[0]}`].join("&"))
                .then(response => {
                    const data = response.data.data;
                    const labels = [];
                    const datasets = [
                        { label: 'Contratos', data: [] },
                    ];

                    data.forEach((item, idx) => {
                        if (!labels[idx]) {
                            labels[idx] = item.usuario;
                        }
                        datasets[0].data.push(item.total);
                    });

                    this.usuariosContratosMesMaiores = {
                        labels: labels,
                        datasets: datasets,
                    }
                });
        },
        loadMenoresUsuarios() {
            let date = this.datePiker;
            Contrato.usuariosQuantidade([`data=${date.toISOString().split('T')[0]}`, `desc=1`].join("&"))
                .then(response => {
                    const data = response.data.data;
                    const labels = [];
                    const datasets = [
                        { label: 'Contratos', data: [] },
                    ];

                    data.forEach((item, idx) => {
                        if (!labels[idx]) {
                            labels[idx] = item.usuario;
                        }
                        datasets[0].data.push(item.total);
                    });

                    this.usuariosContratosMesMenores = {
                        labels: labels,
                        datasets: datasets,
                    }
                });
        },
        loadMeses() {
            Contrato.mesesQuantidade()
                .then(response => {
                    const data = response.data.data;
                    const labels = [];
                    const datasets = [
                        { label: 'Contratos', data: [] },
                    ];

                    data.forEach((item, idx) => {
                        if (!labels[idx]) {
                            labels[idx] = item.mes;
                        }
                        datasets[0].data.push(item.total);
                    });

                    this.contratosMes = {
                        labels: labels,
                        datasets: datasets,
                    }

                    // contratosMes: {
                    //     labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro' ],
                    //     datasets: [
                    //         { label: 'Contratos', data: [55, 49, 60, 81, 46, 25, 50, 55, 49, 60, 81, 46] }
                    //     ],
                    // },
                });
        },
        loadEstados() {
            Contrato.estadosQuantidade()
                .then(response => {
                    const data = response.data.data;
                    const labels = [];
                    const datasets = [
                        { label: 'Contratos', data: [] },
                    ];

                    data.forEach((item, idx) => {
                        if (!labels[idx]) {
                            labels[idx] = `${item.estado} (${item.uf})`;
                        }
                        datasets[0].data.push(item.total);
                    });

                    this.atuacaoEstado = {
                        labels: labels,
                        datasets: datasets,
                    }

                    // atuacaoEstado: {
                    //     labels: [    "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI",
                    //         "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"],
                    //     datasets: [
                    //         { label: 'Contratos', data: [5, 9, 60, 81, 4, 15, 40, 7, 10, 60, 81, 120, 100, 49, 60, 1, 0, 0, 50, 55, 49, 60, 0, 46, 48, 76, 27] }
                    //     ],
                    // },
                });
        },
        loadTotais() {
            Cliente.total()
                .then(response => {
                    this.infosGerais.totalClientes = response.data.total
                });
            Usuario.totalAtivo()
                .then(response => {
                    this.infosGerais.totalUsuarios = response.data.total
                });
            Contrato.totalConcluidoVigente()
                .then(response => {
                    this.infosGerais.totalContratosAtivos = response.data.total
                });
            Contrato.totalContratacao()
                .then(response => {
                    this.infosGerais.totalEmContratacao = response.data.total
                });
            Pendencia.totalPendente()
                .then(response => {
                    this.infosGerais.totalPendencias = response.data.total
                });
        },
        loadClientes() {
            Contrato.clientesQuantidade()
                .then(response => {
                    const data = response.data.data;
                    const labels = [];
                    const datasets = [
                        { label: 'Contratos', data: [] },
                    ];

                    data.forEach((item, idx) => {
                        if (!labels[idx]) {
                            labels[idx] = item.cliente;
                        }
                        datasets[0].data.push(item.total);
                    });

                    this.contratoMaioresClientes = {
                        labels: labels,
                        datasets: datasets,
                    }

                    // contratoMaioresClientes: {
                    //         labels: [
                    //             'Banco do Sul', 'Banco Realista', 'Banco Nacional', 'Banco Capital', 'Banco União',
                    //             'Escola Paulista', 'Banco do Brasil', 'Escola Futuro', 'Banco Econômico', 'Escola Esperança',
                    //             'Banco Integra', 'Escola Progresso', 'Banco Global', 'Escola São Paulo', 'Escola do Saber'
                    //         ],
                    //         datasets: [
                    //             { label: 'Contratos', data: [250, 230, 215, 205, 190, 185, 175, 160, 155, 150, 140, 130, 125, 120, 115] }
                    //         ],
                    //     },
                });
        }

    }
}
</script>
